import axios from "axios";
import { format } from "date-fns";
import {
  editThisAndFollowingEvents,
  editThisEvent,
} from "../../../../Calendar/calendarFunctions";
import { baseUrl } from "../../../../assets/Animations";
import "./large-view-multiple-event-warning.css";
const LargeViewMultipleEventWarning = ({
  tryToClosePopup,
  setChangeMultipleEvents,
  event,
  setOpenEvent,
  setAllEvents,
  setEditing,
  socket,
  initialDateTimeRef,
}) => {
  const myToken = localStorage.getItem("token");
  const myHeader = { headers: { Authorization: `Bearer ${myToken}` } };

  const closeItAllOut = (boo) => {
    setEditing(boo);
    setChangeMultipleEvents(boo);
  };

  const justOne = async () => {
    await editThisEvent(
      event,
      initialDateTimeRef.current,
      setAllEvents,
      closeItAllOut,
      socket,
      event.teacherName,
      myHeader
    );
    axios.post(`${baseUrl}/slack/${event.school}`, {
      message: `${event.teacherName} rescheduled ${event.studentName} ${
        event.familyName
      }'s lesson from ${format(
        new Date(initialDateTimeRef.current),
        "EEEE MMMM do h:mm a"
      )} to ${format(new Date(event.dateTime), "EEEE MMMM do h:mm a")}`,
    });
  };

  const allOfThem = async () => {
    await editThisAndFollowingEvents(
      event,
      initialDateTimeRef.current,
      setAllEvents,
      closeItAllOut,
      socket,
      event.teacherName,
      myHeader
    );
    axios.post(`${baseUrl}/slack/${event.school}`, {
      message: `${event.teacherName} rescheduled all of ${event.studentName} ${
        event.familyName
      }'s lessons from ${format(
        new Date(initialDateTimeRef.current),
        "EEEE h:mm a"
      )} to ${format(
        new Date(event.dateTime),
        "EEEE h:mm a"
      )} starting ${format(new Date(initialDateTimeRef.current), "MMMM do")}`,
    });
  };

  return (
    <div
      className="teacher-calendar-event-editing__repeat-event__wrapper"
      id="teacher-calendar-event-editing__repeat-event__wrapper"
      onClick={(e) => tryToClosePopup(e.target.id)}
    >
      <div
        className="teacher-calendar-event-editing__repeat-event-options__wrapper"
        id="teacher-calendar-event-editing__repeat-event-options__wrapper"
      >
        <div className="teacher-calendar-event-editing__repeat-event-options">
          <div className="teacher-calendar-event-editing__repeat-event-label">
            This is a repeating event.
          </div>
          <div
            className="teacher-calendar-event-editing__repeat-event-button"
            onClick={() => justOne()}
          >
            Save for this event only
          </div>
          <div
            className="teacher-calendar-event-editing__repeat-event-button"
            onClick={() => allOfThem()}
          >
            Save for this & future events
          </div>
        </div>
        <div
          className="teacher-calendar-event-editing__repeat-event-cancel"
          onClick={() => setChangeMultipleEvents(false)}
        >
          Cancel
        </div>
      </div>
    </div>
  );
};
export default LargeViewMultipleEventWarning;
